import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customTranslate',
  pure: false
})
export class CustomTranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: any, defaultValue: string): string {
    return value.nameTranslations?.find(t => t.code === this.translateService.currentLang)?.value ?? value[defaultValue];
  }
}